import { FedwireTransaction, TransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchFedwireFundTransaction({ bearer }: { bearer: string }) {
  const [fetching, setFetching] = useState(false);
  const [fedwireFundTransaction, setFedwireFundTransaction] = useState<FedwireTransaction>();

  async function fetchFedwireFundTransaction(params: TransactionRequest) {
    try {
      setFetching(true);
      const res = await api.fetchFedwireFundTransaction(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setFedwireFundTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fedwireFundTransaction, fetchFedwireFundTransaction };
}
